export enum BrandEnum {
  Bugatti = 'bugatti',
  Elwin = 'elwin',
  Bagatt = 'bagatt',
  daniel_hechter = 'daniel_hechter',
  Salamander = 'salamander'
}
